import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { forwardRef as m } from "react";
const p = m(function({
  title: l,
  subtitle: r,
  actions: t,
  children: s,
  ariaLabel: n = "a11y.pageHeader",
  sticky: d = !0,
  className: i,
  ...c
}, o) {
  return /* @__PURE__ */ a(
    "header",
    {
      ref: o,
      "aria-label": n,
      "data-component": "PageHeader",
      className: "border-b border-subtle bg-bg-surface px-6 py-4 " + (d ? "sticky top-0 z-base " : "") + (i || ""),
      ...c,
      children: [
        /* @__PURE__ */ a("div", { className: "flex items-start justify-between gap-4", children: [
          /* @__PURE__ */ a("div", { className: "min-w-0 flex-1", children: [
            /* @__PURE__ */ e("h1", { className: "text-xl font-extrabold tracking-snug text-primary", children: l }),
            r ? /* @__PURE__ */ e("div", { "data-region": "subtitle", className: "mt-1 text-sm text-secondary", children: r }) : null
          ] }),
          t ? /* @__PURE__ */ e("div", { "data-region": "actions", className: "flex shrink-0 items-center gap-2", children: t }) : null
        ] }),
        s ? /* @__PURE__ */ e("div", { "data-region": "extra", className: "mt-3", children: s }) : null
      ]
    }
  );
});
export {
  p as P
};
//# sourceMappingURL=PageHeader-CgUoa4gJ.js.map
